// Date keys are local calendar dates. UTC is used only for integer day arithmetic,
// never to convert the visitor's local date to a different timezone.
export function dateKey(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function dayNumber(key) {
  const [year, month, day] = key.split('-').map(Number);
  return Date.UTC(year, month - 1, day) / 86400000;
}

export function isDateKey(key) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) return false;
  const [year, month, day] = key.split('-').map(Number);
  const date = new Date(year, month - 1, day, 12);
  return dateKey(date) === key;
}

export function addDays(key, days) {
  const date = new Date((dayNumber(key) + days) * 86400000);
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
}

export function formatDate(key, options = { day: 'numeric', month: 'short', year: 'numeric' }) {
  if (!key) return 'Select dates';
  const [year, month, day] = key.split('-').map(Number);
  return new Date(year, month - 1, day, 12).toLocaleDateString('en-US', options);
}

export function monthDays(month) {
  const [year, number] = month.split('-').map(Number);
  const count = new Date(year, number, 0, 12).getDate();
  const offset = (new Date(year, number - 1, 1, 12).getDay() + 6) % 7;
  return [...Array(offset).fill(null), ...Array.from({ length: count }, (_, i) => `${month}-${String(i + 1).padStart(2, '0')}`)];
}

export function moveMonth(month, amount) {
  const [year, number] = month.split('-').map(Number);
  return dateKey(new Date(year, number - 1 + amount, 1, 12)).slice(0, 7);
}

export function selectRange(range, day) {
  if (!range.start || range.end || day <= range.start) return { start: day, end: '' };
  return { start: range.start, end: day };
}
